module.exports = __webpack_public_path__ + "static/img/ic_jst.19457fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erp/ic_jst.png
// module id = cJD7
// module chunks = 1